export const PATTERN_DATA_ATTRIBUTE = 'pattern';
export const PATTERN_DATA_ATTRIBUTE_INITIALIZED = `${PATTERN_DATA_ATTRIBUTE}-initialized`;
export const PATTERN_SELECTOR = `[data-${PATTERN_DATA_ATTRIBUTE}]`;
export const PATTERN_SELECTOR_INITIALIZED = `[data-${PATTERN_DATA_ATTRIBUTE_INITIALIZED}]`;
export const PATTERN_DELIMITER = '|';

/**
 * Locate any elements within a context block that are associated with a JavaScript-enhanced component.
 *
 * @param elContext {DOmNode}
 * @param sSelector {String}
 * @param sSelectorToExclude {String}
 * @returns {NodeList}
 */
export function locate(elContext = document, sSelector = PATTERN_SELECTOR, sSelectorToExclude = PATTERN_SELECTOR_INITIALIZED) {
	return elContext.querySelectorAll(sSelectorToExclude ? `${sSelector}:not(${sSelectorToExclude})` : sSelector);
}

/**
 * Loop through the passed node list and initialize the component associated with each node. Also mark the node as having
 * been initialized to prevent future duplicated initialization. The functionality to prevent duplicate initilization is
 * outside of the responsibility of this module. Consider implementing such logic in the component itself through a
 * destroy method/logic.
 *
 * @param fnLoad {Function}
 * @param nlPatterns {NodeList}
 * @param sPatternIdentifierAttribute {String}
 * @param sSeparator {String}
 * @param sPatternInitializedAttribute {String}
 * @returns nlElements {NodeList}
 */
export function initialize(fnLoad, nlPatterns = locate(), sPatternIdentifierAttribute = PATTERN_DATA_ATTRIBUTE, sSeparator = PATTERN_DELIMITER, sPatternInitializedAttribute = PATTERN_DATA_ATTRIBUTE_INITIALIZED) {
	// loop through the passed node list

	[...nlPatterns].forEach((elPattern) => {
		// read the names of the component(s) through which the element should be enhanced
		const sComponentNames = elPattern.dataset[sPatternIdentifierAttribute];

		// Recommendation: Even though it is supported, don't use multiple components on one element. Most times a better
		// approach would be to create a component which extends and controls the involved, 'child' components.
		const aComponentNames = sComponentNames.split(sSeparator);

		// loop through the components associated with the current node and initialize each one.
		aComponentNames.forEach((sComponentName) => {
			fnLoad(sComponentName, (pattern) => {
				if (pattern.init) {
					pattern.init(elPattern);
				}
			});
		});

		// mark the node as having been initialized
		elPattern.setAttribute(`data-${sPatternInitializedAttribute}`, true);
	});

	return nlPatterns;
}
